import React, { useEffect, useState } from "react";
import ProjectsSelect from "../../elements/projects/ProjectsSelect";
import { TextField } from "@material-ui/core";
import axios from "axios";
import DefaultButton from "../../styles/materialButtonStyle";
import RiskScoreCurrencySelect from "../../elements/riskScore/RiskScoreCurrencySelect";
import Notification from "../../elements/notification/Notification";
import userAuthenticationConfig from "../../../utils/userAuthenticationConfig";
import { check2FA } from "../../../utils/check2FA";
import getUserInfo from "../../../utils/getUserInfo";
import WAValidator from "multicoin-address-validator";
import { useTranslation } from "react-i18next";

import {
  StyledDialogAction,
  StyledDialogContent,
  StyledDialogHead,
  StyledDialogWrapper
} from "../../styles/styledDialog";
import { StyledRiskScoreInvoiceWrapper } from "../styledRiskScore";
import MaterialDialog from "../../styles/materialDialog";

const RiskScoreInvoice = ({ fetchRiskScore }) => {
  const { t } = useTranslation("riskScorePage");
  const first = 0;
  const [open, setOpen] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const defaultData = {
    "service": null,
    "project": null,
    "asset": null,
    "address": null,
    "txhash": null,
    "twofa": null
  };

  const [invoiceData, setInvoiceData] = useState(defaultData);

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    setDisabled(false);
  }, [notification]);

  const getConnection = () => {
    let data = {
      "service": "SumSub",
      "project": invoiceData.project.name
    };

    return axios.get("/api/connections?project.name=" + data.project + "&service.name=" + data.service,
      userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        return response.data["hydra:member"];
      }
    }).catch(error => {
      handleClose();
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  };

  const createInvoice = async () => {
    setDisabled(true);
    let check2Fa = await check2FA(getUserInfo()["userId"], invoiceData.twofa);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    if (!WAValidator.validate(invoiceData.address, invoiceData.asset)) {
      setNotification({ ...notification, visible: true, type: "error", message: t("riskScoreInvoice.errors.invalidAddress") });
      return;
    }

    if (invoiceData.txhash.length === 0 || invoiceData.txhash.length > 256) {
      setNotification({ ...notification, visible: true, type: "error", message: t("riskScoreInvoice.errors.invalidTxHash") });
      return;
    }

    const connection = await getConnection();

    if (connection.length === 0){
      setNotification({ ...notification, visible: true, type: "error", message: t("riskScoreInvoice.errors.emptyService") });
      return;
    }

    let data = {
      attributes: [
        {
          attribute: 1,
          value: invoiceData.address
        },
        {
          attribute: 2,
          value: invoiceData.txhash
        },
        {
          attribute: 3,
          value: invoiceData.asset
        }
      ],
      callBackUrl: "https://test.com",
      connection: connection[first].id,
      schema: "RiskScore"
    };

    axios.post("/api/risk-scores", data, userAuthenticationConfig(false)).then(response => {
      if (response.status === 201) {
        fetchRiskScore();
        setNotification({ ...notification, visible: true, type: "success", message: t("riskScoreInvoice.success") });
        handleClose();
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.detail });
      handleClose();
    });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setInvoiceData(defaultData);
    setOpen(false);
  };

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledRiskScoreInvoiceWrapper className="risk-score-head__create-invoice">
        <DefaultButton
          color="success"
          onClick={handleClickOpen}
        >
          {t("riskScoreInvoice.form.check")}
        </DefaultButton>
        <MaterialDialog
          open={open}
        >
          <StyledDialogWrapper>
            <StyledDialogHead>
              {t("riskScoreInvoice.form.title")}
            </StyledDialogHead>
            <StyledDialogContent>
              <ProjectsSelect
                checkedProjects={invoiceData.project}
                setCheckedProjects={(data) => setInvoiceData({ ...invoiceData, "project": data })}
                isObject={true}
              />
              <RiskScoreCurrencySelect
                checkedCurrency={invoiceData.asset}
                setCheckedCurrency={(data) => setInvoiceData({ ...invoiceData, "asset": data })}
              />
              <TextField
                id="address"
                label={t("riskScoreInvoice.form.address")}
                value={invoiceData.address}
                onChange={(data) => setInvoiceData({ ...invoiceData, "address": data.target.value })}
              />
              <TextField
                id="txhash"
                label="TX-hash"
                value={invoiceData.txhash}
                onChange={(data) => setInvoiceData({ ...invoiceData, "txhash": data.target.value })}
              />
              <TextField
                id="twofa"
                label={t("riskScoreInvoice.form.twoFa")}
                value={invoiceData.twofa}
                onChange={(data) => setInvoiceData({ ...invoiceData, "twofa": data.target.value })}

              />
            </StyledDialogContent>
            <StyledDialogAction col="2">
              <DefaultButton
                onClick={handleClose}
                color="danger"
                disabled={disabled}
              >
                {t("riskScoreInvoice.form.cancel")}
              </DefaultButton>
              <DefaultButton
                onClick={createInvoice}
                color="success"
                disabled={disabled}
              >
                {t("riskScoreInvoice.form.check")}
              </DefaultButton>
            </StyledDialogAction>
          </StyledDialogWrapper>
        </MaterialDialog>
      </StyledRiskScoreInvoiceWrapper>
    </>
  );
};

export default RiskScoreInvoice;